export default function Testimonials() {
  const testimonials = [
    {
      name: '王小姐',
      role: '上班族',
      content: '服務很專業，幫我找到最划算的方案，省了不少錢！店員很有耐心，推薦給大家！',
      rating: 5,
      date: '2 週前'
    },
    {
      name: '李先生',
      role: '學生',
      content: '手機種類很齊全，店員很有耐心解說，而且價格很實在，會再回購！',
      rating: 5,
      date: '1 個月前'
    },
    {
      name: '陳太太',
      role: '家庭主婦',
      content: '第一次來就感受到專業的服務，幫全家人都辦好門號了，非常滿意！',
      rating: 5,
      date: '3 週前'
    },
    {
      name: '張經理',
      role: '企業用戶',
      content: '公司門號都在這裡辦理，價格透明，服務迅速，合作多年都很放心。',
      rating: 5,
      date: '1 週前'
    },
    {
      name: '林小姐',
      role: '學生',
      content: '配件種類多，價格實在，店員推薦的保護殼很好用！',
      rating: 5,
      date: '2 個月前'
    },
    {
      name: '黃先生',
      role: '工程師',
      content: '線上諮詢很方便，快速解決問題，不用特地跑一趟，讚！',
      rating: 5,
      date: '1 個月前'
    }
  ];

  return (
    <section id="testimonials" className="py-24 bg-gradient-to-br from-slate-50 to-gray-100">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="text-center mb-16">
          <div className="inline-flex items-center space-x-2 mb-4">
            <i className="ri-google-fill text-2xl text-blue-600"></i>
            <span className="text-sm font-medium text-gray-600">Google 評論</span>
          </div>
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
            聽聽客戶怎麼說
          </h2>
          <div className="flex items-center justify-center space-x-2">
            <div className="flex space-x-1">
              {[1, 2, 3, 4, 5].map((star) => (
                <i key={star} className="ri-star-fill text-yellow-400 text-xl"></i>
              ))}
            </div>
            <span className="text-lg font-semibold text-gray-900">5.0</span>
            <span className="text-gray-600">· 基於 150+ 則評論</span>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {testimonials.map((testimonial, index) => (
            <div key={index} className="bg-white rounded-2xl p-6 shadow-sm hover:shadow-md transition-shadow">
              <div className="flex items-start justify-between mb-4">
                <div className="flex items-center space-x-3">
                  <div className="w-12 h-12 rounded-full bg-gradient-to-br from-teal-400 to-blue-500 flex items-center justify-center text-white font-semibold text-lg">
                    {testimonial.name.charAt(0)}
                  </div>
                  <div>
                    <div className="font-semibold text-gray-900">{testimonial.name}</div>
                    <div className="text-sm text-gray-600">{testimonial.role}</div>
                  </div>
                </div>
                <i className="ri-google-fill text-xl text-blue-600"></i>
              </div>

              <div className="flex items-center space-x-1 mb-3">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-yellow-400 text-base"></i>
                ))}
              </div>

              <p className="text-gray-700 leading-relaxed mb-3 text-sm">
                {testimonial.content}
              </p>

              <div className="text-xs text-gray-500">
                {testimonial.date}
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-12">
          <a 
            href="https://www.google.com/maps/place/%E4%BA%AB%E8%B2%B7%E6%89%8B%E6%A9%9F3C%E9%80%9A%E8%A8%8A-%E5%93%A1%E6%9E%97%E5%BA%97(B%26O%E6%8E%88%E6%AC%8A%E7%B6%93%E9%8A%B7)%E3%80%8C%E9%AB%98%E5%83%B9%E5%9B%9E%E6%94%B6%E4%BA%8C%E6%89%8B%E6%A9%9F%2F%E9%96%80%E8%99%9F%2F%E7%A9%BA%E6%A9%9F%2F%E9%85%8D%E4%BB%B6%2F%E7%B6%AD%E4%BF%AE%2F%E7%84%A1%E5%8D%A1%E5%88%86%E6%9C%9F%E3%80%8D/@23.9591555,120.5742809,17z/data=!4m8!3m7!1s0x346937b0eab0c2bf:0xb5623c3bb9e143b2!8m2!3d23.9591506!4d120.5768558!9m1!1b1!16s%2Fg%2F11wqkkm7py?entry=ttu&g_ep=EgoyMDI1MTIwMi4wIKXMDSoASAFQAw%3D%3D" 
            target="_blank" 
            rel="noopener noreferrer"
            className="inline-flex items-center space-x-2 text-teal-600 hover:text-teal-700 font-medium cursor-pointer"
          >
            <span>查看所有 Google 評論</span>
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}
